import React from "react";
import Frame from "../../../components/elements/Frame/index.js";
import { Text } from "@bookingcom/bui-react";
const FareFeatureHeading = ({ children }) => (React.createElement(Frame, { mb: 2 },
    React.createElement(Text, { variant: "small_1", color: "neutral_alt" }, children)));
export default FareFeatureHeading;
